import { render, staticRenderFns } from "./OnlineBasic.vue?vue&type=template&id=2c137696&scoped=true&"
import script from "./OnlineBasic.vue?vue&type=script&lang=js&"
export * from "./OnlineBasic.vue?vue&type=script&lang=js&"
import style0 from "../../../assets/css/project-detail.css?vue&type=style&index=0&id=2c137696&scoped=true&lang=css&"
import style1 from "../../../assets/css/table.css?vue&type=style&index=1&id=2c137696&scoped=true&lang=css&"
import style2 from "../../../assets/css/chunkUpload.css?vue&type=style&index=2&id=2c137696&scoped=true&lang=css&"
import style3 from "../../../assets/css/project-manage.css?vue&type=style&index=3&id=2c137696&scoped=true&lang=css&"
import style4 from "./OnlineBasic.vue?vue&type=style&index=4&id=2c137696&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c137696",
  null
  
)

export default component.exports